'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.moveMultipleElements = exports.updateLocation = undefined;

var _lodash = require('lodash');

var _undoRedoTransactionManager = require('../utils/undoRedo/undoRedoTransactionManager');

var _scoreCalculator = require('../../common/elements/listOrderScores/scoreCalculator');

var _elementHelper = require('../../common/elements/elementHelper');

var _resourceUtil = require('../utils/services/http/resources/resourceUtil');

var _timeUtil = require('../../common/utils/timeUtil');

var _elementUtil = require('./elementUtil');

var _immutableHelper = require('../../common/utils/immutableHelper');

var _sortUtil = require('../../common/utils/sortUtil');

var _elementSelector = require('./elementSelector');

var _boardSelector = require('./board/boardSelector');

var _inboxActions = require('../inbox/inboxActions');

var _elementConstants = require('../../common/elements/elementConstants');

var TYPES = _interopRequireWildcard(_elementConstants);

var _elementsConstants = require('../../common/elements/elementsConstants');

var ELEMENTS_ACTION_TYPE = _interopRequireWildcard(_elementsConstants);

var _boardConstants = require('../../common/boards/boardConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Base actions


// Actions


// Selectors


// Utils
var moveMultipleElementsAction = function moveMultipleElementsAction(_ref) {
    var moves = _ref.moves,
        _ref$sync = _ref.sync,
        sync = _ref$sync === undefined ? true : _ref$sync,
        _ref$transactionId = _ref.transactionId,
        transactionId = _ref$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref$transactionId;
    return {
        type: TYPES.ELEMENT_MOVE_MULTI,
        moves: moves,
        sync: sync,
        modified: (0, _timeUtil.getTimestamp)(),
        transactionId: transactionId
    };
};

// Constants
// Lib


var getFromLocation = function getFromLocation(initialState, elementId) {
    var initialElementState = (0, _elementSelector.getElement)(initialState, { elementId: elementId });
    return initialElementState.get('location').toJS();
};

var addFromLocation = function addFromLocation(initialState) {
    return function (move) {
        move.from = getFromLocation(initialState, move.id);
        return move;
    };
};

var getMoveScoreGroupKey = function getMoveScoreGroupKey(move) {
    return move.location.parentId + '.' + move.location.position.index;
};

var moveRequiresScoreCalculation = function moveRequiresScoreCalculation(elements, boardResourcesState) {
    return function (move) {
        // elements and then increment by that amount for each element
        var location = move.location;
        // If the move is not to an inbox, then it doesn't need any complex calculations and can fire immediately

        if (location.section !== _boardConstants.BOARD_SECTIONS.INBOX) return false;

        // If it already has a score, use it rather than calculate it again (useful when undoing)
        if (location.position.score != null) return false; // eslint-disable-line eqeqeq

        // check to see if we have access to the children of the board that's having a child added to its inbox
        var parentBoardResource = boardResourcesState.get(location.parentId);
        var parent = elements.get(location.parentId);

        // If we don't have it, then we can't calculate the score of the new item, so we just leave it as null for the
        // server to take care of
        if (!parent || (0, _elementHelper.isBoard)(parent) && !(0, _resourceUtil.isFetched)(parentBoardResource)) return false;

        return true;
    };
};

var resetScores = function resetScores(_ref2) {
    var parentId = _ref2.parentId,
        section = _ref2.section;
    return {
        type: ELEMENTS_ACTION_TYPE.ELEMENTS_RESET_SCORES,
        parentId: parentId,
        section: section,
        sync: true
    };
};

var getGroupScores = function getGroupScores(getState, moveGroup) {
    var state = getState();
    var elements = state.get('elements');

    var location = moveGroup[0].location;
    var inboxElements = (0, _elementHelper.getSortedChildrenInSection)(elements, location.section, location.parentId);

    var currentScores = inboxElements.map((0, _immutableHelper.propIn)(['location', 'position', 'score'])).sort(_sortUtil.numbersAscending).toJS();

    return (0, _scoreCalculator.getNewScores)(currentScores, location.position.index, moveGroup.length);
};

var buildScoreMap = function buildScoreMap(dispatch, getState) {
    return function (moves) {
        var state = getState();
        var elements = state.get('elements');
        var boardResourcesState = (0, _boardSelector.boardResourcesSelector)(state);

        var movesRequiringScoreCalculation = moves.filter(moveRequiresScoreCalculation(elements, boardResourcesState));

        // Group moves by parentId.index
        var groupedMoves = (0, _lodash.groupBy)(movesRequiringScoreCalculation, getMoveScoreGroupKey);

        // Calculate the scores for each one of those groups
        return (0, _lodash.mapValues)(groupedMoves, function (moveGroup) {
            var newScores = getGroupScores(getState, moveGroup);

            // If the score is null a collision has occurred, so we need to refresh all elements scores before attempting
            // to insert this new / moved element
            if (newScores == null) {
                // eslint-disable-line eqeqeq
                dispatch(resetScores(location));

                // Try to calculate the scores again
                newScores = getGroupScores(getState, moveGroup) || [];
            }

            return {
                currentIndex: 0,
                newScores: newScores
            };
        });
    };
};

/**
 * Updates the location object with a score if necessary.
 * This will happen when the location is within the INBOX section.  The index of the element will relate to a score
 * which will enforce the ordering between cards.
 *
 * If a score collision happens (i.e. two elements end up with the same score) this method will also dispatch the
 * 'ELEMENTS_RESET_SCORES' action which will recalculate the scores for every element and then attempt to calculate the
 * score again.
 */
var updateLocation = exports.updateLocation = function updateLocation(dispatch, getState) {
    return function (moves) {
        var scoreMap = buildScoreMap(dispatch, getState)(moves);

        var state = getState();
        var elements = state.get('elements');
        var boardResourcesState = (0, _boardSelector.boardResourcesSelector)(state);

        return function (move) {
            if (!moveRequiresScoreCalculation(elements, boardResourcesState)(move)) return move;

            var scoreMapKey = getMoveScoreGroupKey(move);
            var scoreEntry = scoreMap[scoreMapKey];
            var _scoreEntry$currentIn = scoreEntry.currentIndex,
                currentIndex = _scoreEntry$currentIn === undefined ? 0 : _scoreEntry$currentIn,
                _scoreEntry$newScores = scoreEntry.newScores,
                newScores = _scoreEntry$newScores === undefined ? [] : _scoreEntry$newScores;

            (0, _lodash.set)(move, 'location.position.score', newScores[currentIndex]);
            (0, _lodash.set)(scoreEntry, 'currentIndex', currentIndex + 1);

            return move;
        };
    };
};

/**
 * Ensures that a move won't result in a recursive structure.
 * NOTE: This only checks the initial state, not the end state! It would be possible to
 * configure a move such that a recursive structure was possible.
 */
var checkMoveSafety = function checkMoveSafety(state) {
    return function (move) {
        var elements = (0, _elementSelector.getElements)(state);
        var ancestorIds = (0, _elementUtil.getPhysicalAncestorIds)(elements, move.location.parentId);

        // If the moved element exists in the ancestors of the
        var isSafeMove = !(0, _lodash.includes)(ancestorIds, move.id);
        if (!isSafeMove) {
            console.warn("Paradox: Unable to perform move as the moved element exists in the location's ancestry.", move);
        }
        return isSafeMove;
    };
};

/**
 * If the move being performed doesn't actually change anything (i.e. an element is dropped onto the same position
 * in a list) then don't perform the move, as it's a wasted effort.
 */
var shouldMove = function shouldMove(state) {
    return function (move, order) {
        var id = move.id,
            location = move.location;

        // Can't move an element that we don't know about

        var element = (0, _elementSelector.getElement)(state, { elementId: id });
        if (!element) return false;

        if (location.section !== _boardConstants.BOARD_SECTIONS.INBOX) return true;

        var elements = (0, _elementSelector.getElements)(state);
        var inboxElements = (0, _elementHelper.getSortedChildrenInSection)(elements, location.section, location.parentId);

        // The final index is the dropped location plus the order that the element is in when it's moved.
        var finalIndex = location.position.index + order;
        var elementAtIndex = inboxElements.get(finalIndex);

        return elementAtIndex ? elementAtIndex.get('id') !== id : true;
    };
};

/**
 * Dispatches a move event for an element, given the location to move the element to.
 * The location's position will be updated with a 'score' if necessary.
 */
var moveMultipleElements = exports.moveMultipleElements = function moveMultipleElements(_ref3) {
    var moves = _ref3.moves,
        _ref3$sync = _ref3.sync,
        sync = _ref3$sync === undefined ? true : _ref3$sync,
        _ref3$transactionId = _ref3.transactionId,
        transactionId = _ref3$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref3$transactionId;
    return function (dispatch, getState) {
        // Add the from location to the moves
        var initialState = getState();

        var isSafeMultiMove = moves.every(checkMoveSafety(initialState));
        if (!isSafeMultiMove) {
            // TODO Dispatch a warning action that displays a message explaining why the move failed
            console.warn('Preventing moves as a paradox will occur.');
            return;
        }

        var updatedMoves = moves.filter(shouldMove(initialState))
        // NOTE: This assumes that all moves are going to the same parentId & section.  If this assumption becomes
        //  incorrect, further work will need to be done here
        .map(updateLocation(dispatch, getState)(moves)).map(addFromLocation(initialState));

        // If we no longer need to perform any moves, just finish
        if (!updatedMoves.length) return;

        dispatch(moveMultipleElementsAction({ moves: updatedMoves, sync: sync, transactionId: transactionId }));

        // if you're dropping on a board that isn't the current one, open up it's unsorted notes
        dispatch((0, _inboxActions.setInboxFromMultiElementMove)({ moves: updatedMoves, transactionId: transactionId }));
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/elementMoveActions.js
// module id = 302
// module chunks = 0